import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function AdminSidebar({ onNavigate }) {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  const menuItems = [
    { name: "Dashboard", path: "/admin/dashboard", icon: "📊" },
    { name: "Produk", path: "/admin/products", icon: "🛍️" },
    { name: "Slider", path: "/admin/sliders", icon: "🖼️" },
    { name: "Buat Invoice", path: "/admin/invoices", icon: "📄" },
    { name: "Pengaturan Web", path: "/admin/settings", icon: "⚙️" },
  ];

  return (
    <>
      <div className="admin-sidebar-header">
        <h2 className="admin-brand">Admin Panel</h2>
        <p className="admin-status">HandyCraft Bali</p>
      </div>
      <nav className="admin-nav">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`admin-nav-item ${isActive(item.path) ? "active" : ""}`}
            onClick={onNavigate}
          >
            <span className="admin-nav-icon">{item.icon}</span>
            <span className="admin-nav-text">{item.name}</span>
          </Link>
        ))}
      </nav>
      <div className="admin-sidebar-footer">
        <Link to="/" className="admin-nav-item" onClick={onNavigate}>
          <span className="admin-nav-icon">🏠</span>
          <span className="admin-nav-text">Lihat Toko</span>
        </Link>
      </div>
    </>
  );
}
